import template from './leave_taken_by_leave_type.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportLeaveTakenByLeaveTypeViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		let first_day = moment().format('YYYY-MM-01');
		let last_day = moment().format('YYYY-MM-') + moment().daysInMonth();

		this.leave_types = ko.observableArray();
		this.leave_type_id = ko.observable();

		this.date_start = ko.observable(new Date(first_day).toJSON().slice(0, 10));
		this.date_end = ko.observable(new Date(last_day).toJSON().slice(0, 10));

		this.leave_dep_summary = ko.observableArray();
		this.reportFieldNames = ko.observableArray();

		this.current_department_id = ko.observable();
		this.selected_department = ko.observable();

		this.leave_report = ko.observableArray();
		this.show_hint = ko.observable(true);
		this.show_no_data_message = ko.observable(false);

		this.selected_department.subscribe((newValue) => {
			this.leave_report([]);
			this.show_hint(true);
			this.show_no_data_message(false);
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.page.updateData();
			}
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});

		this.end_date_timeout = null;
		this.start_date_timeout = null;

		this.date_start.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.start_date_timeout) 
				clearTimeout(this.start_date_timeout);

			// Set new timeout to wait for user to finish typing or selecting date
			this.start_date_timeout = setTimeout(() => {
				let sd = moment(newValue, 'YYYY-MM-DD', true);
				if (!sd.isValid()) return;

				// Update end date to last day of start date month
				let month_end = moment(sd).endOf('month').format('YYYY-MM-DD');
				this.date_end(month_end);
			}, 500); 
		});

		this.date_end.subscribe((newValue) => {
			if (!newValue) return;

			// Clear any existing timeout
			if (this.end_date_timeout) 
				clearTimeout(this.end_date_timeout);

			// Set new timeout to wait for user to finish typing
			this.end_date_timeout = setTimeout(() => {
				let ed = moment(newValue, 'YYYY-MM-DD', true);
				if (!ed.isValid()) return;

				if (newValue.length === 10)
				{
					let sd = moment(this.date_start(), 'YYYY-MM-DD', true);
					if (sd.isValid() && ed.isBefore(sd))
					{
						Grape.alerts.alert({
							type: 'error',
							title: tr('Invalid Date Range'),
							message: tr('End date cannot be before start date')
						});
						return;
					}
				}
			}, 1000);
		});

		this.leave_type_id.subscribe((newText) => {
			this.page.updateData();
		});
	}

	update_click()
	{
		this.show_hint(false);
		this.page.updateReportData();
	}

	async download_clicked(v, e)
	{
		// Check if there's any data to download
		if (this.leave_report().length === 0) {
			await Grape.alerts.alert({title: 'Warning', type: 'warning', message: 'No data to download'});
			return;
		}

		// Build CSV from the actual data array
		let csv_rows = [];

		// Add header row
		let headers = [
			'Employee',
			'Employee code',
			'Department',
			'Leave type',
			'Reason',
			'Amount',
			'From date',
			'To date'
		];

		// If transaction_id is visible (for developers), add it to headers
		if (Grape.currentSession.roles.includes('developer')) {
			headers.push('Transaction ID');
		}

		csv_rows.push(headers.map(h => `"${h}"`).join(','));

		// Add data rows from the observable array
		this.leave_report().forEach(record => {
			let row = [
				record.fullname || '',
				record.employee_code || '',
				record.department || '',
				record.description || '',
				record.reason || '',
				record.total_days || '',
				record.range_start || '',
				record.range_end || ''
			];

			// Add transaction_id for developers if it exists
			if (Grape.currentSession.roles.includes('developer')) {
				row.push(record.transaction_id || '');
			}

			// Properly escape quotes and wrap in quotes
			csv_rows.push(row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','));
		});

		let csv_string = csv_rows.join('\n');

		// Create and download the file
		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'leave_taken_report_by_leave_type.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	show_report_help()
	{
		Grape.dialog.open('LeaveTakenByLeaveTypeHelp', { 'employee_id': this.page.bindings.id }, {});
	}
}

class ReportTakenLeavePageByLeaveType
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportLeaveTakenByLeaveTypeViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('LeaveTakenByLeaveTypeReport'))
			return;

		document.title = tr('Leave Taken By Leave Type');
		window.current_page_title(tr('Leave Taken By Leave Type'));

		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'leave_type',
			limit: 100,
			sortfield: 'description',
			sortorder: 'ASC'
		});

		if (res)
			this.viewModel.leave_types(res.records);
	}

	updateData()
	{
		if (this.viewModel.current_department_id() != '' && this.viewModel.date_start() && this.viewModel.date_end())
		{
			let sd = moment(this.viewModel.date_start(), 'YYYY-MM-DD', true);
			let ed = moment(this.viewModel.date_end(), 'YYYY-MM-DD', true);
		}
	}

	async updateReportData()
	{
		let data = {
			department_id: this.viewModel.current_department_id(),
			leave_type_id: this.viewModel.leave_type_id(),
			date_start: this.viewModel.date_start(),
			date_end: this.viewModel.date_end()
		};

		this.viewModel.loader(true);

		let res = await Grape.fetches.postJSON('/reports/leave_taken_report_by_leave_type', data);

		if (res.leave_taken === null)
			this.viewModel.show_no_data_message(true);

		if(res)
		{
			if (res.leave_taken && !Grape.currentSession.roles.includes('developer'))
				for (let i=0; i<res.leave_taken.length; i++)
					res.leave_taken[i].transaction_id = null;

			this.viewModel.leave_report(res.leave_taken);
			this.viewModel.show_hint(false);
			this.viewModel.loader(false);
			this.viewModel.show_no_data_message(false);
		}
	}
}

export default {
	route: '[/]report/leave_taken_by_leave_type',
	page_class: ReportTakenLeavePageByLeaveType,
	template: template,
	template_filename: 'translation/leave_taken_by_leave_type'
};
